import { createAsyncThunk } from '@reduxjs/toolkit';
import httpService from './httpService';

export const getOrdersList: any = createAsyncThunk<any>(
	'getOrdersList',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'/productService/order/orders',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const getPendingCount: any = createAsyncThunk<any>(
	'getPendingCount',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'/productService/order/orders',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const updateOrderStatus: any = createAsyncThunk<any>(
	'updateOrderStatus',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.put(
				'/productService/order/orders',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const getOrderDetails: any = createAsyncThunk<any>(
	'getOrderDetails',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get('/productService/order', {
				params: data
			});
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const getOrderStats: any = createAsyncThunk<any>(
	'getOrderStats',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'/productService/order/orderStats',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const printLabel: any = createAsyncThunk<any>(
	'printLabel',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.post(
				'/productService/report',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const updateInfo: any = createAsyncThunk<any>(
	'updateInfo',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.put(
				'/productService/order',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const checkOrderLink: any = createAsyncThunk<any>(
	'checkOrderLink',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'/productService/order/checkOrderUsers',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const checkOrderEmail: any = createAsyncThunk<any>(
	'checkOrderEmail',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'/productService/orderV2/checkOrderUsers',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const orderReport: any = createAsyncThunk<any>(
	'orderReport',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'/productService/order/orderReport',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const getAccountBalance: any = createAsyncThunk<any>(
	'getAccountBalance',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'/tenant-portal/accountBalance',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const checkPreApproved: any = createAsyncThunk<any>(
	'checkPreApproved',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.put(
				'/productService/orderV2/checkPreApproved',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);